// extracted by mini-css-extract-plugin
module.exports = {"headingContainer":"WqOb1x0_csL5MSO0NWl7T","headingActive":"_2GoCgdDoBXaOFaFgMG69x-","heading":"_2GFg7fLZDMk7kod2GTezBU"};